import { Message } from '@connect-x-app/shared-domain-models';
import { SortOptions } from '@connect-x-app/shared-types';

export const sortMessagesByDate = (a: Message, b: Message, sort = SortOptions.ASC): number => {
  const aTime = new Date(a.createdAt).getTime();
  const bTime = new Date(b.createdAt).getTime();

  if (sort === SortOptions.DESC) {
    return aTime - bTime;
  } else {
    return bTime - aTime;
  }
};
